import axios from "axios";
import { url } from "../config";
import errorToast from "../../components/helper-components/error-toast";
import { attachApiErrorMessage } from "./api-error-message";

export const api = axios.create({
  baseURL: url,
  timeout: 60000,
  headers: { "Content-Type": "application/json" },
});
export const adminapi = axios.create({
  timeout: 60000,
  headers: { "Content-Type": "application/json" },
});

let cposUrlPromise = null;
export const getCposUrl = () => {
  if (!cposUrlPromise) {
    const storeId = "STR0002";
    cposUrlPromise = api
      .get(`/store/cposURL?store_id=${storeId}`)
      .then((res) => {
        const cposUrl = res?.data?.data;
        if (!cposUrl) {
          cposUrlPromise = null;
          errorToast("Please add CPOS Url in store details");
        }
        return cposUrl;
      })
      .catch((error) => {
        cposUrlPromise = null;
        errorToast("Please add CPOS Url in store details");
        throw error;
      });
  }
  return cposUrlPromise;
};

adminapi.interceptors.request.use(
  async (config) => {
    if (!config.baseURL) {
      config.baseURL = (await getCposUrl()) + '/api';
    }
    if (localStorage.getItem("accessToken")) {
      config.headers["Authorization"] = localStorage.getItem("accessToken");
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

adminapi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(attachApiErrorMessage(error))
);

api.interceptors.request.use(
  async (config) => {
    
    if (localStorage.getItem("accessToken")) {
      if (!excludeAccessToken(config)) {
        config.headers["Authorization"] = localStorage.getItem("accessToken");
      }
    }
    return config;
  },
  (error) => {
    
    return Promise.reject(error);
  }
);
api.interceptors.response.use(
  async (config) => {
    
    return config;
  },
  async (error) => {
    attachApiErrorMessage(error);
    if (
      error.response?.status === 401 &&
      !excludeAccessToken(error.config)
    ) {
      // Auth endpoints (login, forgot/reset password) return 401 for bad
      // credentials — let the caller show that error instead of logging out.
      sessionStorage.setItem("sessionExpired", "1");
      window.location.href = "/logout";
    }
    return Promise.reject(error);
  }
);

function excludeAccessToken(config) {
  return (
    config.url.includes("/user/login") ||
    config.url.includes("/user/forgot/password") ||
    config.url.includes("/user/reset/password") ||
    config.url.includes("/core/auth/forgot-password") ||
    config.url.includes("/core/auth/reset-password") ||
    config.url.includes("/configuration/site-settings/logo-title")
  );
}
